import './ConstructorItem.css';const constructorItem = "_constructorItem_7j7ln_1";
const styles = {
  constructorItem
};
export {
  constructorItem,
  styles as default
};
